import { ReactNode } from 'react';
import { GlobalStyles } from '@mui/material';
import { useConfig } from 'core/common/hooks';
import { DevThemeControls, DynamicPreloaders, Header } from 'core/common/ui/widgets';
import { ScreenAttributes } from 'core/flow/entities';
import { BodyStyled, PageWrapperStyled } from './styled';

type FlowLayoutProps = {
  screenId: string;
  initialScreenId: string;
  screenAttributes: ScreenAttributes;
  nextScreenAttributes: ScreenAttributes | null;
  children: ReactNode;
};

export const FlowLayout = ({
  screenId,
  screenAttributes,
  nextScreenAttributes,
  initialScreenId,
  children,
}: FlowLayoutProps) => {
  const { isDevelopment } = useConfig();

  return (
    <>
      <DynamicPreloaders
        screenId={screenId}
        initialScreenId={initialScreenId}
        screenAttributes={screenAttributes}
        nextScreenAttributes={nextScreenAttributes}
      />
      <GlobalStyles
        styles={(theme) => ({
          body: {
            backgroundColor: theme.palette.background.mainBodyDesktop,
          },
        })}
      />
      <BodyStyled $background={screenAttributes.background} data-testid={screenId}>
        {isDevelopment && <DevThemeControls />}
        <Header screenId={screenId} />
        <PageWrapperStyled component="main" maxWidth="container">
          {children}
        </PageWrapperStyled>
      </BodyStyled>
    </>
  );
};
